
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ServerSettingsPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"server"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forbidSysUserRename"}},{"kind":"Field","name":{"kind":"Name","value":"disableIpLogging"}},{"kind":"Field","name":{"kind":"Name","value":"forbidCreateDnsSubZone"}},{"kind":"Field","name":{"kind":"Name","value":"forbidSubscriptionRename"}},{"kind":"Field","name":{"kind":"Name","value":"fullHostName"}},{"kind":"Field","name":{"kind":"Name","value":"includeAdminDumps"}},{"kind":"Field","name":{"kind":"Name","value":"includeDatabases"}},{"kind":"Field","name":{"kind":"Name","value":"includeDomainDumps"}},{"kind":"Field","name":{"kind":"Name","value":"includeLogs"}},{"kind":"Field","name":{"kind":"Name","value":"includeMailLists"}},{"kind":"Field","name":{"kind":"Name","value":"includeMailboxes"}},{"kind":"Field","name":{"kind":"Name","value":"includeMssqlDatabases"}},{"kind":"Field","name":{"kind":"Name","value":"includePgsqlDatabases"}},{"kind":"Field","name":{"kind":"Name","value":"includeMysqlDatabases"}},{"kind":"Field","name":{"kind":"Name","value":"includeRemoteDatabases"}},{"kind":"Field","name":{"kind":"Name","value":"logrotateAnonymizeIps"}},{"kind":"Field","name":{"kind":"Name","value":"logrotateForce"}},{"kind":"Field","name":{"kind":"Name","value":"logrotatePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"preferredDomain"}},{"kind":"Field","name":{"kind":"Name","value":"sizeCountType"}},{"kind":"Field","name":{"kind":"Name","value":"trafficAccounting"}},{"kind":"Field","name":{"kind":"Name","value":"trafficStatisticsPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"webDeployIncludePassword"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPumAllowed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"os"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isUnix"}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manageServerSettingsHostname"}}]}}]}}]}}],"loc":{"start":0,"end":1005}};
    doc.loc.source = {"body":"query ServerSettingsPage {\r\n    server {\r\n        settings {\r\n            forbidSysUserRename\r\n            disableIpLogging\r\n            forbidCreateDnsSubZone\r\n            forbidSubscriptionRename\r\n            fullHostName\r\n            includeAdminDumps\r\n            includeDatabases\r\n            includeDomainDumps\r\n            includeLogs\r\n            includeMailLists\r\n            includeMailboxes\r\n            includeMssqlDatabases\r\n            includePgsqlDatabases\r\n            includeMysqlDatabases\r\n            includeRemoteDatabases\r\n            logrotateAnonymizeIps\r\n            logrotateForce\r\n            logrotatePeriod\r\n            preferredDomain\r\n            sizeCountType\r\n            trafficAccounting\r\n            trafficStatisticsPeriod\r\n            webDeployIncludePassword\r\n        }\r\n    }\r\n    mode {\r\n        isPumAllowed\r\n    }\r\n    os {\r\n        isUnix\r\n    }\r\n    viewer {\r\n        login\r\n        permissions {\r\n            manageServerSettingsHostname\r\n        }\r\n    }\r\n}\r\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ServerSettingsPage"] = oneQuery(doc, "ServerSettingsPage");
        
